import { Box, Stack } from "@mui/material"
import { NoResults } from "lib/@components/no-results/no-results"

export function ExtendedNoResults({ message, component }) {
    return (
        <Stack spacing={2} sx={{ alignItems: "center", mt: 2 }}>
            <NoResults>{message}</NoResults>
            <Box>{component}</Box>
        </Stack>
    )
}
